import { updateGeneratorSelected } from 'js/store/actions/graphGeneratorData';
export function mapPlotMetadataAndDispatchToGeneratorSelectedHandler(plotId, dispatch) {
  return function (generatorId, selected) {
    dispatch(updateGeneratorSelected(plotId, generatorId, selected));
  };
}

function mapPlotMetadataToDefaultDataGetParams() {
  // (plotMetadata) {
  return {};
}

export function mapPlotMetadataToGraphDataGetParams(plotMetadata) {
  return mapPlotMetadataToDefaultDataGetParams(plotMetadata);
}
export function mapPlotMetadataToPlotId(plotMetadata) {
  return plotMetadata.name;
}
export function mapPlotMetadataToSectionId(plotMetadata) {// TODO: just use the name instead
}
export function mapPlotMetadataToDownloadText(plotMetadata) {
  return plotMetadata.buttonDownload;
}
export function mapPlotMetadataToSectionGraphId(plotMetadata) {
  return "".concat(mapPlotMetadataToSectionId(plotMetadata), "_graph");
} // TODO: not receiving a short title at the moment

export function mapPlotMetadataToSectionLabel(plotMetadata) {
  return plotMetadata.label;
}
export function mapPlotMetadataToDataUrl(plotMetadata, country) {
  return "/countries/".concat(country).concat(plotMetadata.dataUrl); // TODO: remove slash in dataUrl?
}

function mapPlotMetadataAndCountryPlotDataToPlotDataWrapper(plotMetadata, countryPlotData) {
  return countryPlotData[mapPlotMetadataToPlotId(plotMetadata)];
}

export function mapPlotMetadataAndCountryPlotDataToPlotData(plotMetadata, countryPlotData) {
  return (mapPlotMetadataAndCountryPlotDataToPlotDataWrapper(plotMetadata, countryPlotData) || {}).data;
}
export function mapPlotMetadataAndCountryPlotDataToPlotMetaData(plotMetadata, countryPlotData) {
  return (mapPlotMetadataAndCountryPlotDataToPlotDataWrapper(plotMetadata, countryPlotData) || {}).metadata;
}
export function mapPlotMetadataAndCountryPlotDataToPlotDataLoading(plotMetadata, countryPlotData) {
  return (mapPlotMetadataAndCountryPlotDataToPlotDataWrapper(plotMetadata, countryPlotData) || {}).loading;
}
export function mapPlotMetadataAndCountryPlotDataToPlotDataUpdating(plotMetadata, countryPlotData) {
  return (mapPlotMetadataAndCountryPlotDataToPlotDataWrapper(plotMetadata, countryPlotData) || {}).updating;
}
export function mapPlotMetadataAndCountryPlotDataToPlotDataValid(plotMetadata, countryPlotData) {
  return mapPlotMetadataAndCountryPlotDataToPlotDataLoading(plotMetadata, countryPlotData) || mapPlotMetadataAndCountryPlotDataToPlotDataUpdating(plotMetadata, countryPlotData) || mapPlotMetadataAndCountryPlotDataToPlotData(plotMetadata, countryPlotData);
}